var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('kombat-chat',{attrs:{"id":"kombatchat","theme":"dark","site":"fk","name":"fkchat"}})}
var staticRenderFns = []

export { render, staticRenderFns }